export default "__VITE_ASSET__DSgNqNYF__"